// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  asteroidId: __t.string().primaryKey(),
  lobbyId: __t.string(),
  posX: __t.i32(),
  posY: __t.i32(),
  velX: __t.i32(),
  velY: __t.i32(),
  sizeLevel: __t.u16(),
  rotation: __t.f32(),
  rotationSpeed: __t.f32(),
  health: __t.f32(),
  maxHealth: __t.f32(),
  updatedAt: __t.timestamp(),
});
